
import {
    CORE_LOAD_LIST_SEARCH_ONEDRIVE_REQUEST,
    CORE_LOAD_LIST_SEARCH_ONEDRIVE_SUCCESS,
    CORE_LOAD_LIST_SEARCH_ONEDRIVE_FAILURE,

    REQUEST_STATE
} from '../types'
const requestState = REQUEST_STATE

export default {
    items: (state = requestState, action) => {
        switch (action.type) {
            case CORE_LOAD_LIST_SEARCH_ONEDRIVE_REQUEST:
                return state
            case CORE_LOAD_LIST_SEARCH_ONEDRIVE_SUCCESS:
                if (action.payload && !Array.isArray(action.payload) && typeof action.payload === "object") {
                    const { result, datas } = action.payload
                    if (result && datas) {
                        return datas
                    }
                    return []
                } else return []
            case CORE_LOAD_LIST_SEARCH_ONEDRIVE_FAILURE:
                return []
            default:
                return state
        }
    },
}



// WEBPACK FOOTER //
// ./src/app/redux/reducers/oneDrive.js